import type { IconProps } from '../types/IconProps.ts';
export const Unlink: IconProps = {
    name: 'Unlink',
    children: [
        `<path d="m16.46 20.21.68 2.13M3.93 7.3l-2.11-.75M19.68 17.09l2.1.74M7.15 4.17l-.68-2.13M12.95 4.46a5 5 0 1 1 7.07 7.08l-2.83 2.82a5 5 0 0 1-7.07 0" />`,
        `<path d="M11.54 20.02a5 5 0 1 1-7.08-7.07l2.83-2.83a5 5 0 0 1 7.07 0" />`,
    ]
};